import { render, staticRenderFns } from "./FedExAddressStep.vue?vue&type=template&id=08009828&scoped=true"
import script from "./FedExAddressStep.vue?vue&type=script&lang=ts"
export * from "./FedExAddressStep.vue?vue&type=script&lang=ts"
import style0 from "./FedExAddressStep.vue?vue&type=style&index=0&id=08009828&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08009828",
  null
  
)

export default component.exports